module.exports = __webpack_public_path__ + "img/img_smile_04.88e07aa5.svg";